import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { GlobalSearchResultItemDataObject } from 'models/service';

export const getRecentSearches = async () =>
  apiClient.get<GlobalSearchResultItemDataObject[], ApiClientResponse<GlobalSearchResultItemDataObject[]>>(
    routes.recentSearches.find,
  );
